export const ValletTransactionsViewControls = {
  viewControl: {
    dateFilterOptions: [
      { key: 'created_at', val: 'Created At' },
    ],
  }
}

export const transactionColumns = [
  {
    title: 'Customer Code',
    dataIndex: 'customer_code',
    key: 'customer_code',
  },
  {
    title: 'Transaction Date and Time',
    dataIndex: 'created_at',
    key: 'created_at',
  },
    {
    title: 'Transaction Created By',
    dataIndex: 'created_by',
    key: 'created_by',
  },
  {
    title: 'Transaction Type',
    dataIndex: 'transaction_type',
    key: 'transaction_type',
  },
  {
    title: 'Reference Number',
    dataIndex: 'consignment_reference_number',
    key: 'consignment_reference_number',
  },
  {
    title: 'Carrier AWB Number',
    dataIndex: 'courier_partner_reference_number',
    key: 'courier_partner_reference_number',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: 'Transaction Notes',
    dataIndex: 'notes',
    key: 'notes',
  },
];

export const headerMapping = {
  'Customer Code' : 'customer_code',
  'Amount' : 'amount',
  'Amount Type(Final/Additional)' : 'amount_type',
  'Notes' : 'notes',
  'Consignment Reference Number': 'consignment_reference_number',
  'Carrier AWB Number': 'courier_partner_reference_number',
};

export const getTransactionEntity = (type) => type === 'CN' ? 'CONSIGNMENT' : 'WALLET';
